
import { Vue, Component, Model, Watch, Prop } from 'vue-property-decorator';
import lazyInject from '@/di';
import VehicleService from '@/services/vehicle.service';

@Component
export default class TagsField extends Vue {
  val: any = '';

  @lazyInject(VehicleService)
  private vehicleService!: VehicleService;

  useTofieldOptions = [];

  @Prop()
  readonly!: boolean;

  @Prop()
  placeholder!: string;

  @Prop()
  tagslist!: any;

  @Prop()
  tagsList!: any;

  getLabel(arr: any, val: any) {
    let _text = '';
    arr.forEach((res: any) => {
      if (res.value === val) {
        _text = res.label;
      }
    });
    return _text;
  }

  @Prop()
  disabled!: boolean;

  @Prop()
  labelId!: string;

  @Watch('val')
  changeVal() {
    this.$emit('change', this.val);
  }

  @Model('change')
  value!: any;

  // changeColor(val: string) {
  //   this.val = val;
  // }

  @Watch('value')
  watchValue() {
    if (this.value) {
      this.val = this.value;
    } else {
      this.val = undefined;
    }
  }

  throwTags(id: any, list: any) {
    return list.filter((item: any) => item.id === +id)[0] || '';
  }

  changeTag(item: any) {
    if (this.val.includes(item.id)) {
      this.val = this.val.filter((i: any) => i !== item.id);
    } else {
      this.val.push(item.id);
    }
  }

  breakDown(val: any) {
    const _a: any = [];
    Object.keys(val).forEach((key) => {
      _a.push({
        value: Number(key),
        label: val[key],
      });
    });
    return _a;
  }

  async mounted() {
    const res = await this.vehicleService.getCommodityCategory({
      label_id: this.labelId,
    });
    this.useTofieldOptions = res;
    this.watchValue();
  }
}
